module.exports = __webpack_public_path__ + "img/no-image.af879c88.jpeg";